const popperStyle = (anchorEl) => ({
  zIndex: 1300,
  width: anchorEl?.offsetWidth,
});

const mentionUsersListSx = {
  maxHeight: 240,
  overflowY: 'auto',
};

export {
  popperStyle,
  mentionUsersListSx,
};
